import React from 'react';
import Icon from '@atlaskit/icon/core/show-more-horizontal';
export var ShowMoreHorizontalIcon = function ShowMoreHorizontalIcon(_ref) {
  var label = _ref.label,
    testId = _ref.testId,
    color = _ref.color,
    shouldRecommendSmallIcon = _ref.shouldRecommendSmallIcon,
    spacing = _ref.spacing;
  return /*#__PURE__*/React.createElement(Icon, {
    label: label,
    testId: testId,
    color: color,
    shouldRecommendSmallIcon: shouldRecommendSmallIcon,
    spacing: spacing,
    size: "small"
  });
};